module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/about/1-e61f22d164fad98a2076def8fc42cd85.jpg";